import { Space, Tabs } from "antd";
import React, { useEffect } from "react";
import CustomTabs, { tabsProps } from "../../../../../../components/Tabs";
import AccountingCode from "./AccountingCode";
import RecuringComponents from "./RecuringComponents";
import AdHocComponents from "./AdHocComponents";
import { useLocation, useNavigate } from "react-router-dom";

const SalaryComponents = () => {
    const locations = useLocation();
    const navigateto = useNavigate();
    const [activeTab] = React.useState<string>(locations.pathname);

    const Tabs: tabsProps[] = [
        { key: 'recurring-components', label: 'Recurring Components', content: <RecuringComponents /> },
        { key: 'ad-hoc-components', label: 'Ad - hoc Components', content: <AdHocComponents /> },
        { key: 'accounting-code', label: 'Accounting Code', content: <AccountingCode /> },
    ]

    useEffect(() => {
        navigateto(`${activeTab}/${Tabs[0].key}`, { replace: true });
    }, []);

    const onTabChange = (activeKey: string) => {
        console.log(activeKey);
    }

    return <CustomTabs tabs={Tabs} routes={true} onTabChange={onTabChange} />
}

export default SalaryComponents;